<template>
    <q-page class="row full-width" :style="pageStyle">


        <!-- LEFT PANEL / MOBILE PANEL  -->
        <div class="col-xs-12 col-sm-6" >

            <div class="column justify-around" style="height: 100vh">

                <!-- LOGO  -->
                <div class="row full-width flex flex-center q-pa-lg">
                    <q-img
                        alt="Logo"
                        :src="$store.state.config.launch.logo_url"
                        contain
                        style="height: 100px; max-height:100px"
                    />
                </div>

                <!-- LOGIN COMPONENT  -->
                <div class="row full-width flex flex-center ">
                    <q-card :dark="dark">
                        <BaseLogin />
                    </q-card>
                </div>

                <!-- APP NAME  -->
                <q-card v-if="$store.state.config.launch.title || $store.state.config.launch.subtitle || $store.state.config.launch.host_url"
                    flat 
                    :dark="dark"
                    class="row full-width bg-transparent q-pa-md" 
                    >
                    <div v-if="$store.state.config.launch.title" class="row flex flex-center full-width text-bold" style="font-size:1.6em"> 
                        {{ $store.state.config.launch.title }}</div>
                    <div
                    v-if="$store.state.config.launch.subtitle" class="row full-width flex flex-center" style="font-size:1.4em">
                        {{ $store.state.config.launch.subtitle }} 
                    </div>
                    <div v-if="$store.state.config.launch.host_url" class="row full-width flex flex-center" style="font-size:1.0em">
                        {{ $store.state.config.launch.host_url }} 
                    </div>
                    <div v-if="$store.state.config.ip_address" class="row full-width flex flex-center">
                        <span style="font-size:12px" class="text-bold text-overline text-grey-6"> IP Trace: {{ $store.state.config.ip_address }}  </span>
                    </div>
                </q-card>

            </div>
        </div>

        <!-- RIGHT PANEL  -->
        <q-card v-if="!$q.screen.xs" square class="col-xs-12 col-sm-6">
            <div class="row full-width flex flex-center" :style="rightStyle"></div>
        </q-card>
        
    </q-page>

</template>

<script>
import { colors } from 'quasar'
const { brightness } = colors

export default {
    components: {
        BaseLogin: () => import("components/auth/index")
    },

    data() {
        return {
            apiKey: this.$store.state.ids.api_key,
            clientKey: this.$store.state.ids.client_key,
            app: this.$store.state.ids.app,
        }
    },

    created() {
        if (process.env.NODE_ENV !== 'production') console.log("INIT %c BaseAuthIndex", "color: white; background-color: red;padding: 2px");
        this.$q.loading.hide()
    },

    computed: {

        dark() {
            if (this.$store.state.config.dark_mode) return true
            return false
        },

        pageStyle() {
            return {
                backgroundColor: this.$store.state.config.launch.background_color,
                color: this.textColor,
            }
        },

        textColor() {
            if (brightness(this.$store.state.config.launch.background_color) > 128) return "#566573"
            else return '#fafafa'
        },

        rightStyle() {
            return {
                height: '100vh',
                backgroundImage: `url(${this.$store.state.config.launch.login_url})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundColor: this.$store.state.config.launch.background_color,
                backgroundPosition: 'center'
            }
        },

        textClass() {
            if (this.$q.screen.xs) return 'row full-width flex flex-center text-white q-pa-md absolute-bottom'
            else return "row full-width flex flex-center q-mb-mb text-grey-8 absolute-bottom"
        },

        cardStyle() {
            if (this.$q.screen.xs) return {
                backgroundColor: 'rgba(0,0,0,0.4)',
                padding: "40px"
            }
            return {
                padding: "40px"
            }
        }
    },
}
</script>

<style>

</style>